import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, HostBinding, Input, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { RadioGroupComponent } from './radio-group.component';

@Component({
  selector: 'mtg-radio',
  templateUrl: './radio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true
    }
  ],
})
export class RadioComponent implements OnInit, ControlValueAccessor {
  private control: AbstractControl;
  private onTouch: () => void;
  private onChange: (value) => void;

  @Input()
  value: any;
  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  reverse: boolean;
  checked: boolean;
  @HostBinding('class.radio-container')
  defaultClass = true;

  get isReverse(): boolean {
    return (this.radioGroupComponent && this.radioGroupComponent.reverse) || this.reverse;
  }

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective,
    @Optional() private radioGroupComponent: RadioGroupComponent,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    } else {
      this.control = this.formControl;
    }
    if (this.radioGroupComponent) {
      this.radioGroupComponent.value$.subscribe(value => {
        this.checked = this.value === value;
        this.cdr.markForCheck();
      });
    }
  }

  writeValue(obj: any): void {
    this.checked = obj === this.value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  changeValue(): void {
    this.checked = true;
    if (this.onTouch) {
      this.onTouch();
    }
    if (this.onChange) {
      this.onChange(this.value);
    }
    if (this.radioGroupComponent) {
      this.radioGroupComponent.onItemClick(this.value);
    }
  }
}
